export const validPasscode = '123123';
export const invalidPasscode = '777777';
